import type { LibraryCollection } from '../types';
import { COLLECTIONS_CONFIG } from '../constants/collections';

interface Props {
  name: LibraryCollection;
  className?: string;
}

export const CollectionIcon = ({ name, className }: Props) => {
  const config = COLLECTIONS_CONFIG[name];
  
  return (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {config.iconPath}
    </svg>
  );
};